import { useContext } from 'react';
import { DataContext } from '../context/DataProvider';


export const useDataProvider = () => {
    return useContext(DataContext);
};
